
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/brochure-request",
      function () {
        return require("private-next-pages/brochure-request/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/brochure-request"])
      });
    }
  